module.exports = __webpack_public_path__ + "img/hns.8539d8af.svg";